import type { KottiField } from '../kotti-field/types'

export const KOTTI_FIELD_TEXT_SUPPORTS: KottiField.Supports = {
	autoComplete: true,
	borderless: true,
	clear: true,
	decoration: true,
	placeholder: true,
	tabIndex: true,
}
